export const TCPA_SHIELD_HEADERS = [
    {
        name: 'Name',
        value: 'name',
        sortSettings: {
            key: '',
            sortBy: 'byName',
        },
        filterSettings: {},
        disabled: true,
        editAction: true,
    },
    {
        name: 'Campaign',
        value: 'campaigns',
        minWidth: 500,
    },
    {
        name: 'Type',
        value: 'type',
        sortSettings: {
            key: '',
            sortBy: 'byType',
        },
        filterSettings: {},
    },
    {
        name: 'Status',
        value: 'status',
        align: 'center',
        sortSettings: {
            key: '',
            sortBy: 'byStatus',
        },
        filterSettings: {},
        minWidth: 80,
    },
    {
        name: 'Actions',
        value: 'actions',
        minWidth: 114,
        align: 'center',
        disabled: true,
    },
]
